var _desc, _defs, _rect, _ellipse, _path, _ellipse2, _ellipse3, _ellipse4, _path2, _rect2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProductStorefrontCannedSoda(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 240 240",
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, "Canned soda") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", {
    id: "desc"
  }, "A red canned soda product illustration.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "can-body",
    x1: 66,
    y1: 44,
    x2: 174,
    y2: 204,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d94b24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#91011e"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 240,
    height: 240,
    rx: 24,
    fill: "#fff7f5"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 120,
    cy: 50,
    rx: 49,
    ry: 18,
    fill: "#d8dce0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M71 50h98v140c0 14.4-21.9 26-49 26s-49-11.6-49-26V50Z",
    fill: "url(#can-body)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 120,
    cy: 190,
    rx: 49,
    ry: 26,
    fill: "#7b0018"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 120,
    cy: 50,
    rx: 49,
    ry: 18,
    fill: "#f3f4f6"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 120,
    cy: 52,
    rx: 33,
    ry: 9,
    fill: "#b7bec6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M103 46c8-5 25-5 34 0",
    fill: "none",
    stroke: "#6b7280",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 85,
    y: 91,
    width: 70,
    height: 61,
    rx: 10,
    fill: "#ffffff",
    opacity: 0.94
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M98 122c14-26 32-26 45 0",
    fill: "none",
    stroke: "#b23212",
    strokeWidth: 8,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M96 137h48",
    fill: "none",
    stroke: "#91011e",
    strokeWidth: 7,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M90 62c16 9 43 12 68 2",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 5,
    strokeLinecap: "round",
    opacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductStorefrontCannedSoda);
export default __webpack_public_path__ + "static/media/product_storefront_canned_soda.5b7cbcab3362fa52018dd979d4a3d903.svg";
export { ForwardRef as ReactComponent };